import request from '@/utils/request';

export function MoneyManagementAPI() {
    return {
        // 主体列表
        getSubjectList: params => {
            return request({
                url: '/admin/money/management/subject/index',
                method: 'get',
                params,
            });
        },

        //新增主体
        subjectAdded: data => {
            return request({
                url: '/admin/money/management/subject/edit',
                method: 'post',
                data
            });
        },

        //上传营业执照
        fileUpload: data => {
            return request({
                url: '/admin/upload/license',
                method: 'post',
                data
            });
        },

        //主体详情
        subjectInfo: params => {
            return request({
                url: `/admin/money/management/subject/info?id=${params}`,
                method: 'get',
            });
        },

        getSubjectSelect: params => {
            return request({
                url: '/admin/money/management/subject/select',
                method: 'get',
                params,
            });
        },


        //合同列表
        getContractList: params => {
            return request({
                url: '/admin/money/management/contract/index',
                method: 'get',
                params,
            });
        },

        //新增合同
        contractAdded: data => {
            return request({
                url: '/admin/money/management/contract/edit',
                method: 'post',
                data
            });
        },

        //合同详情
        contractInfo: params => {
            return request({
                url: `/admin/money/management/contract/info?id=${params}`,
                method: 'get',
            });
        },

        //合同选择器
        getContractSelect: params => {
            return request({
                url: '/admin/money/management/contract/select',
                method: 'get',
                params,
            });
        },

        //上传营业执照
        fileContractUpload: data => {
            return request({
                url: '/admin/upload/contract',
                method: 'post',
                data
            });
        },


        //收款列表
        getReceivingAccountList: params => {
            return request({
                url: '/admin/money/management/receiving_account/index',
                method: 'get',
                params,
            });
        },

        //新增收款
        receivingAccountAdded: data => {
            return request({
                url: '/admin/money/management/receiving_account/edit',
                method: 'post',
                data
            });
        },

        //收款详情
        receivingAccountInfo: params => {
            return request({
                url: `/admin/money/management/receiving_account/info?id=${params}`,
                method: 'get',
            });
        },

        //收款列表-选择器
        getReceivingAccountSelect: params => {
            return request({
                url: '/admin/money/management/receiving_account/select',
                method: 'get',
                params,
            });
        },

        //团队列表
        getTeamList: params => {
            return request({
                url: '/admin/money/management/team/index',
                method: 'get',
                params,
            });
        },

        //新增团队
        teamAdded: data => {
            return request({
                url: '/admin/money/management/team/edit',
                method: 'post',
                data
            });
        },

        //团队详情
        teamInfo: params => {
            return request({
                url: `/admin/money/management/team/info?id=${params}`,
                method: 'get',
            });
        },

        //团队选择器
        getTeamSelect: params => {
            return request({
                url: '/admin/money/management/team/select',
                method: 'get',
                params,
            });
        },

        //交易类目列表
        getFundingTypeList: params => {
            return request({
                url: '/admin/money/management/funding_type/index',
                method: 'get',
                params,
            });
        },

        //新增交易类目
        fundingTypeAdded: data => {
            return request({
                url: '/admin/money/management/funding_type/edit',
                method: 'post',
                data
            });
        },

        //交易类目详情
        fundingTypeInfo: params => {
            return request({
                url: `/admin/money/management/funding_type/info?id=${params}`,
                method: 'get',
            });
        },

        //交易类目选择器
        getFundingTypeSelect: params => {
            return request({
                url: '/admin/money/management/funding_type/select',
                method: 'get',
                params,
            });
        },

        //小说项目列表
        getShortPlayProjectList: params => {
            return request({
                url: '/admin/money/management/short_play_project/index',
                method: 'get',
                params,
            });
        },

        //新增小说项目
        shortPlayProjectAdded: data => {
            return request({
                url: '/admin/money/management/short_play_project/edit',
                method: 'post',
                data
            });
        },

        //小说项目详情
        shortPlayProjectInfo: params => {
            return request({
                url: `/admin/money/management/short_play_project/info?id=${params}`,
                method: 'get',
            });
        },

        //小说项目详情
        moviesSelect: params => {
            return request({
                url: `/admin/money/management/short_play_project/movie_select`,
                method: 'get',
                params
            });
        },

        //交易类目选择器
        getShortPlayProjectSelect: params => {
            return request({
                url: '/admin/money/management/short_play_project/select',
                method: 'get',
                params,
            });
        },

        //费用订单列表
        getFundingOrderList: params => {
            return request({
                url: '/admin/money/management/funding_order/index',
                method: 'get',
                params,
            });
        },

        //新增费用订单
        fundingOrderAdded: data => {
            return request({
                url: '/admin/money/management/funding_order/edit',
                method: 'post',
                data
            });
        },

        //费用订单详情
        fundingOrderInfo: params => {
            return request({
                url: `/admin/money/management/funding_order/info?id=${params}`,
                method: 'get',
            });
        },

        //用户列表
        getUserList: params => {
            return request({
                url: '/admin/money/management/user/index',
                method: 'get',
                params,
            });
        },

        //编辑用户
        userEdit: data => {
            return request({
                url: '/admin/money/management/user/edit',
                method: 'post',
                data
            });
        },

        //收支类目列表
        getTradeTypeList: params => {
            return request({
                url: '/admin/money/management/trade_type/index',
                method: 'get',
                params,
            });
        },

        //新增收支类目
        tradeTypeAdded: data => {
            return request({
                url: '/admin/money/management/trade_type/edit',
                method: 'post',
                data
            });
        },

        //收支类目详情
        tradeTypeInfo: params => {
            return request({
                url: `/admin/money/management/trade_type/info?id=${params}`,
                method: 'get',
            });
        },

        //收支类目选择器
        getTradeTypeSelect: params => {
            return request({
                url: '/admin/money/management/trade_type/select',
                method: 'get',
                params,
            });
        },

        //项目排期-选择项目列表
        getScheduleProjectSelect: params => {
            return request({
                url: 'admin/money/management/project_schedule/project_select',
                method: 'get',
                params,
            });
        },

         //项目排期-详情
         getScheduleInfo: params => {
            return request({
                url: 'admin/money/management/project_schedule/info',
                method: 'get',
                params,
            });
        },

         //项目排期-列表
         getScheduleIndex: params => {
            return request({
                url: 'admin/money/management/project_schedule/index',
                method: 'get',
                params,
            });
        },

        //项目排期-新增/编辑小说
        getScheduleEdit: data => {
            return request({
                url: 'admin/money/management/project_schedule/edit',
                method: 'post',
                data
            });
        },

        //项目排期-上传项目文件
        getScheduleUpload: data => {
            return request({
                url: 'admin/upload/project_file',
                method: 'post',
                data
            });
        },


        //授权平台-列表
        getAuthPlatformList: data => {
            return request({
                url: 'admin/money/management/authorization_platform/indexs',
                method: 'post',
                data
            });
        },

        //授权平台-下拉列表
        getAuthPlatformSelect: data => {
            return request({
                url: 'admin/money/management/authorization_platform/index',
                method: 'post',
                data
            });
        },
        
        //授权平台-编辑
        authPlatformEdit: data => {
            return request({
                url: 'admin/money/management/authorization_platform/edit',
                method: 'post',
                data
            });
        },

         //授权平台-详情
         getAuthPlatformInfo: params => {
            return request({
                url: `admin/money/management/authorization_platform/info?id=${params}`,
                method: 'get',
                data: params,
            });
        },
        
        
    };
}
